		function setCookie(k, v) {
      let now = new Date();
      now.setMonth( now.getMonth() + 12 );
      document.cookie = k + "=" + escape(v) + ';';
      document.cookie = "expires=" + now.toUTCString() + ";"
      // console.log('setCookie', document.cookie);
		}
    function delCookie(k) {
      let now = new Date();
      now.setMonth( now.getMonth() + 12 );
      document.cookie = k + "=" + ';';
      document.cookie = "expires=" + now.toUTCString() + ";"
      // console.log('delCookie', document.cookie);
    }
		function getCookie(k) {
      const cookie_name = k + '=';
      const cookies = document.cookie;
      let start = cookies.indexOf(cookie_name);
      let cookie_value = '';
      if ( start != -1 ) {
        start += cookie_name.length;
        const end = cookies.indexOf(';', start);
        cookie_value = cookies.substring(start, end);
      }
      // console.log('getCookie', cookie_value);
      return escape(cookie_value);
		}
    const validate = (event) => {
      if ( document.querySelector('input[name="save_username"]').checked ) {
        setCookie('username', document.querySelector('input[name=username]').value);
      }
    }
    document.addEventListener('DOMContentLoaded',function() {
      document.querySelector('input[name="save_username"]').onchange=saveUserEventHandler;
    },false);
    function saveUserEventHandler(event) {
      if ( event.target.checked ) {
        setCookie('username', document.querySelector('input[name=username]').value);
      }
      else {
        delCookie('username');
      }
    }
    document.addEventListener("DOMContentLoaded",function(){
      const saved_username = getCookie('username');
      if ( saved_username ) {
        document.getElementById('id_save_username').checked = true;
        document.getElementById('id_username').value = saved_username;
      }
    });

    document.getElementById('login_form').addEventListener("submit", validate);
